export default __webpack_public_path__ + "static/media/wi-hail.f9552791.svg";